@import "../../../../styles/variables";
:host {
  display: block;
  height: 100vh;
  overflow-y: scroll;
}

.ftm-outer-facet-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: var(--srp-greyscale-100-background-fafafa, #fafafa);
  border-top: 1px solid $svs-super-light-grey;
  font-size: 14px;
  line-height: 20px;

  span::first-letter {
    text-transform: uppercase;
  }
}

filters-tree-node.disable-on-request {
  position: relative;
  &:before {
    content: "";
    display: block;
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
